export const FORM_INPUT_IDS = new Set([
  "mobile-create-doc-title",
  "mobile-create-folder-name",
  "mobile-rename-doc-title",
  "mobile-rename-folder-name",
  "mobile-rename-node-name",
  "mobile-add-node-name",
]);

// Bottom nav = views *of the current document*, and nothing else.
//
// "Docs" is not here — it navigates away from the document, so it lives on the
// top bar (the logo) instead of sitting among the views.
//
// "More" is not here either. It was a grab bag: two document views (mindmap,
// bubbles) mixed with app settings, account actions and log out. The views are
// now first-class tabs; everything else moved to the top bar, where the target
// matches the scope — logo opens the vault, the document name opens that
// document's properties, the avatar opens the account.
//
// [tab, text key]: the label is translated when the nav renders (t() cannot
// run at module load, the language is not loaded yet).
export const NAV_ITEMS = [
  ["outline", "mobile.nav.outline"],
  ["notes", "common.notes"],
  ["routines", "views.name.routines"],
  ["board", "mobile.nav.board"],
  ["timeline", "mobile.nav.timeline"],
  ["mindmap", "common.map"],
  ["bubble", "views.name.bubbles"],
];

export const PERSISTENT_FOCUS_IDS = new Set([
  "mobile-note-search",
  "mobile-node-name",
  "mobile-node-start",
  "mobile-node-end",
  "mobile-node-notes",
  "mobile-note-title",
  "mobile-note-content",
  "mobile-today-add",
  "mobile-create-doc-title",
  "mobile-create-folder-name",
  "mobile-rename-doc-title",
  "mobile-rename-folder-name",
  "mobile-rename-node-name",
  "mobile-add-node-name",
]);

// Zoom buttons "1w", "1m"… : n + unit, labelled when the timeline renders.
export const GANTT_ZOOM_LEVELS = [
  { n: 1, unit: "week", dayWidth: 36 },
  { n: 1, unit: "month", dayWidth: 9 },
  { n: 3, unit: "month", dayWidth: 3 },
  { n: 6, unit: "month", dayWidth: 1.5 },
  { n: 1, unit: "year", dayWidth: 0.75 },
  { n: 2, unit: "year", dayWidth: 0.4 },
  { n: 3, unit: "year", dayWidth: 0.25 },
  { n: 5, unit: "year", dayWidth: 0.15 },
  { n: 10, unit: "year", dayWidth: 0.08 },
];

export const GANTT_ROW_HEIGHT_MIN = 20;
export const GANTT_ROW_HEIGHT_MAX = 110;
